// Sentry must initialise before any module that might throw on import.
// Do not move this line.
import { Sentry } from './sentry';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/base.css';
import App from './app/App';
import { AppErrorFallback } from './app/AppErrorFallback';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={({ resetError }) => <AppErrorFallback onReset={resetError} />}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
